import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::index
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:22
* @route '/onboarding-requests'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/onboarding-requests',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::index
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:22
* @route '/onboarding-requests'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::index
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:22
* @route '/onboarding-requests'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::index
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:22
* @route '/onboarding-requests'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::index
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:22
* @route '/onboarding-requests'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::index
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:22
* @route '/onboarding-requests'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::index
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:22
* @route '/onboarding-requests'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::show
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:56
* @route '/onboarding-requests/{onboardingRequest}'
*/
export const show = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/onboarding-requests/{onboardingRequest}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::show
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:56
* @route '/onboarding-requests/{onboardingRequest}'
*/
show.url = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { onboardingRequest: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { onboardingRequest: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            onboardingRequest: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        onboardingRequest: typeof args.onboardingRequest === 'object'
        ? args.onboardingRequest.id
        : args.onboardingRequest,
    }

    return show.definition.url
            .replace('{onboardingRequest}', parsedArgs.onboardingRequest.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::show
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:56
* @route '/onboarding-requests/{onboardingRequest}'
*/
show.get = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::show
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:56
* @route '/onboarding-requests/{onboardingRequest}'
*/
show.head = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::show
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:56
* @route '/onboarding-requests/{onboardingRequest}'
*/
const showForm = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::show
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:56
* @route '/onboarding-requests/{onboardingRequest}'
*/
showForm.get = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::show
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:56
* @route '/onboarding-requests/{onboardingRequest}'
*/
showForm.head = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::edit
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:63
* @route '/onboarding-requests/{onboardingRequest}/edit'
*/
export const edit = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/onboarding-requests/{onboardingRequest}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::edit
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:63
* @route '/onboarding-requests/{onboardingRequest}/edit'
*/
edit.url = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { onboardingRequest: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { onboardingRequest: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            onboardingRequest: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        onboardingRequest: typeof args.onboardingRequest === 'object'
        ? args.onboardingRequest.id
        : args.onboardingRequest,
    }

    return edit.definition.url
            .replace('{onboardingRequest}', parsedArgs.onboardingRequest.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::edit
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:63
* @route '/onboarding-requests/{onboardingRequest}/edit'
*/
edit.get = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::edit
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:63
* @route '/onboarding-requests/{onboardingRequest}/edit'
*/
edit.head = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::edit
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:63
* @route '/onboarding-requests/{onboardingRequest}/edit'
*/
const editForm = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::edit
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:63
* @route '/onboarding-requests/{onboardingRequest}/edit'
*/
editForm.get = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::edit
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:63
* @route '/onboarding-requests/{onboardingRequest}/edit'
*/
editForm.head = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::update
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:80
* @route '/onboarding-requests/{onboardingRequest}'
*/
export const update = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/onboarding-requests/{onboardingRequest}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::update
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:80
* @route '/onboarding-requests/{onboardingRequest}'
*/
update.url = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { onboardingRequest: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { onboardingRequest: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            onboardingRequest: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        onboardingRequest: typeof args.onboardingRequest === 'object'
        ? args.onboardingRequest.id
        : args.onboardingRequest,
    }

    return update.definition.url
            .replace('{onboardingRequest}', parsedArgs.onboardingRequest.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::update
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:80
* @route '/onboarding-requests/{onboardingRequest}'
*/
update.put = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::update
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:80
* @route '/onboarding-requests/{onboardingRequest}'
*/
const updateForm = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::update
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:80
* @route '/onboarding-requests/{onboardingRequest}'
*/
updateForm.put = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::destroy
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:100
* @route '/onboarding-requests/{onboardingRequest}'
*/
export const destroy = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/onboarding-requests/{onboardingRequest}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::destroy
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:100
* @route '/onboarding-requests/{onboardingRequest}'
*/
destroy.url = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { onboardingRequest: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { onboardingRequest: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            onboardingRequest: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        onboardingRequest: typeof args.onboardingRequest === 'object'
        ? args.onboardingRequest.id
        : args.onboardingRequest,
    }

    return destroy.definition.url
            .replace('{onboardingRequest}', parsedArgs.onboardingRequest.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::destroy
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:100
* @route '/onboarding-requests/{onboardingRequest}'
*/
destroy.delete = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::destroy
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:100
* @route '/onboarding-requests/{onboardingRequest}'
*/
const destroyForm = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OnboardingRequests\OnboardingRequestController::destroy
* @see app/Http/Controllers/Admin/OnboardingRequests/OnboardingRequestController.php:100
* @route '/onboarding-requests/{onboardingRequest}'
*/
destroyForm.delete = (args: { onboardingRequest: string | { id: string } } | [onboardingRequest: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const onboardingRequests = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default onboardingRequests